import { colors, chartColors } from "../theme";

const axisLineStyle = { lineStyle: { color: "rgba(255, 255, 255, 0.12)" } };
const splitLineStyle = { lineStyle: { color: colors.border, type: "dashed" } };

const darkAxisDefaults = {
  axisLine: axisLineStyle,
  axisLabel: { color: colors.textSecondary },
  nameTextStyle: { color: colors.textSecondary },
};

/**
 * Merge chart-specific ECharts options with dark-theme defaults.
 */
export function buildEchartsOptions(options = {}) {
  const xAxis = options.xAxis;
  const yAxis = options.yAxis;

  return {
    backgroundColor: "transparent",
    color: chartColors,
    textStyle: { color: colors.textPrimary },
    tooltip: {
      trigger: "axis",
      backgroundColor: colors.paper,
      borderColor: colors.border,
      textStyle: { color: colors.textPrimary },
      ...options.tooltip,
    },
    legend: {
      textStyle: { color: colors.textSecondary },
      ...options.legend,
    },
    title: options.title
      ? {
          ...options.title,
          textStyle: {
            color: colors.textPrimary,
            ...(options.title.textStyle || {}),
          },
        }
      : undefined,
    grid: options.grid,
    xAxis: Array.isArray(xAxis)
      ? xAxis.map((axis) => ({ ...darkAxisDefaults, splitLine: { show: false }, ...axis }))
      : { ...darkAxisDefaults, splitLine: { show: false }, ...xAxis },
    yAxis: Array.isArray(yAxis)
      ? yAxis.map((axis) => ({ ...darkAxisDefaults, splitLine: splitLineStyle, ...axis }))
      : { ...darkAxisDefaults, splitLine: splitLineStyle, ...yAxis },
    series: options.series,
  };
}

export const rechartsTheme = {
  gridStroke: colors.border,
  axisStroke: "rgba(255, 255, 255, 0.12)",
  tickFill: colors.textSecondary,
  tooltipContentStyle: {
    backgroundColor: colors.paper,
    border: `1px solid ${colors.border}`,
    borderRadius: 8,
    color: colors.textPrimary,
  },
  legendStyle: { color: colors.textSecondary },
};

export { chartColors, colors };
